<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 6C16 6 14 12 8 12C2 12 0 6 0 6C0 6 2 0 8 0C14 0 16 6 16 6ZM12 6C12 8.20914 10.2091 10 8 10C5.79086 10 4 8.20914 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
  />
</template>
